var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAllowedForShowing
    ? _c(
        "div",
        {
          staticClass: "global-search-input-modal-wrapper",
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              return _vm.closeModal()
            }
          }
        },
        [
          _c("img", {
            staticClass: "close-img",
            attrs: {
              src: require(`@/drc/assets/icons/close-search.svg`),
              alt: "close"
            },
            on: {
              click: function($event) {
                return _vm.closeModal()
              }
            }
          }),
          _c(
            "div",
            { staticClass: "global-search-input-modal-container" },
            [
              _c("GlobalSearch"),
              _c(
                "button",
                {
                  staticClass: "close-modal",
                  on: {
                    click: function($event) {
                      return _vm.closeModal()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("globalSearchSections.cancel")))]
              ),
              _c("GlobalSearchResultsDropdown")
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }